module.exports = __webpack_public_path__ + "img/brand-cases14.b80fbc23.png";